




























import Vue from 'vue';
import {Component, Prop} from "vue-property-decorator";
import Modal from "./Modal.vue";

@Component({
    components: {
        Modal
    }
})
export default class RefundPreamble extends Vue {
    @Prop() feeFree: boolean;
    showingFeeFreeModal: boolean = false;
}
